import { container } from './di/container';
import { Cat } from './cat';
import { Tree } from './tree';
import { Canyon } from './canyon';
import { Pit } from './pit';
import { Collectable } from './collectable';
import { Poop } from './poop';
import { Glass } from './glass';
import { HUD } from './ui/hud';
import { CollisionManager } from './collision/collision-manager';
import { CloudManager } from './cloud';
import { SoundManager } from './audio/sound-manager';
import { InputManager } from './input-manager';
import { GameTime } from './game-time';

let cat: Cat;
import { PoopFrames } from './poop';

let poops: Poop[] = [];
let poopFrames: PoopFrames;
let tree: Tree;
let canyon: Canyon;
let pit: Pit;
let collectable: Collectable;
let glass: Glass;
let hud: HUD;
let collisionManager: CollisionManager;
let cloudManager: CloudManager;
let inputManager: InputManager;
let gameTime: GameTime;
let isLoading = true;
const cameraZoom = 2;
let landTileLeft: p5.Image;
let landTileMiddle: p5.Image;
let landTileRight: p5.Image;
let groundBuffer: p5.Graphics; // Pre-rendered ground tiles
let lastStartButtonState = false;
// Kamera smooth takip için
let cameraX = 0;
let cameraY = 0;
const cameraLerpSpeed = 0.3; // 0.1 = çok yavaş, 0.3 = hızlı, 0.5 = çok hızlı

function resetGame(): void {
	// Game over durumunda restart yapılamaz
	if (cat.isDead()) {
		return;
	}

	const groundY = 432 - 32;
	const groundLevel = 432;
	// Cat'in mevcut health'ini koru
	const oldHealth = cat.currentHealth;
	// Cat'i yeniden oluştur (sprite'lar zaten yüklü, constructor'da tekrar yüklenmeyecek)
	const oldAnimationManager = cat.animationManager;
	cat = new Cat(20, groundY);
	cat.groundY = groundY;
	// AnimationManager'ı koru (sprite'lar için)
	cat.animationManager = oldAnimationManager;
	// Health'i koru (canlar persist olmalı)
	cat.currentHealth = oldHealth;
	// Setup callbacks
	setupCatCallbacks(groundLevel);
	// AnimationManager'ı resetle
	cat.animationManager.reset();
	tree = new Tree(795, groundLevel);
	canyon = new Canyon(groundLevel);
	pit = new Pit(80, groundLevel);
	pit.setLandTiles(landTileLeft, landTileRight);
	collectable = new Collectable(420, 420, 16);
	glass.reset(300, groundLevel);
	// Reset collision system and register new objects
	collisionManager.clear();
	collisionManager.register(collectable);
	collisionManager.register(pit);
	collisionManager.register(tree);
	collisionManager.register(glass);
	// Clear poops
	poops = [];
	cloudManager.reset();
	hud.reset();
	lastStartButtonState = false;
	// Kamerayı da resetle
	cameraX = cat.x + 32;
	cameraY = cat.y - 40;
}

function setupCatCallbacks(groundLevel: number = 432): void {
	cat.onDamage = (health: number) => {
		hud.setHealth(health);
	};
	cat.onHeal = (health: number) => {
		hud.setHealth(health);
	};
	cat.onDeath = () => {
		hud.setGameOver(true);
	};
	cat.onPoop = (x: number, y: number) => {
		const poop = new Poop(x, y, groundLevel);
		poop.setFrames(poopFrames);
		poops.push(poop);
		collisionManager.register(poop);
	};
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).setup = async function () {
	// P2D renderer kullan (GPU hızlandırmalı)
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	createCanvas(1024, 576, (window as any).P2D);
	// Pixel art için image smoothing'i kapat
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const ctx = (window as any).drawingContext;
	if (ctx) {
		ctx.imageSmoothingEnabled = false;
		// Not: willReadFrequently attribute'u canvas oluşturulurken set edilmeli
		// p5.js bunu desteklemediği için browser uyarısı görünebilir
		// Ancak performans etkisi minimal ve sprite yükleme sadece başlangıçta yapılıyor
	}

	// Resolve singletons from DI container
	collisionManager = container.resolve(CollisionManager);
	inputManager = container.resolve(InputManager);
	gameTime = container.resolve(GameTime);
	const soundManager = container.resolve(SoundManager);

	const groundY = 432 - 32;
	const groundLevel = 432;
	cat = new Cat(20, groundY);
	cat.groundY = groundY;
	tree = new Tree(795, groundLevel);
	canyon = new Canyon(groundLevel);
	pit = new Pit(80, groundLevel);
	collectable = new Collectable(420, 420, 16);
	glass = new Glass(150, groundLevel);
	glass.y = 250; // Start from above to test breaking animation
	hud = new HUD(9);
	cloudManager = new CloudManager();

	// Register collidables
	collisionManager.register(collectable);
	collisionManager.register(pit);
	collisionManager.register(tree);
	collisionManager.register(glass);

	// Load sounds and sprites
	await soundManager.loadAll();
	await cat.loadSprites();
	await glass.loadSprite();
	poopFrames = await Poop.loadSprite();
	// Load land tileset (16x48: left corner, middle, right corner)
	const landTileset = await new Promise<p5.Image>((resolve) => {
		loadImage('./assets/models/land-tileset.png', (img) => resolve(img));
	});
	// Slice tileset into 3 tiles using get() - yatay tileset (48x16)
	landTileLeft = landTileset.get(0, 0, 16, 16);
	landTileMiddle = landTileset.get(16, 0, 16, 16);
	landTileRight = landTileset.get(32, 0, 16, 16);
	pit.setLandTiles(landTileLeft, landTileRight);

	// Pre-render ground tiles to a single buffer (seam-free, performant)
	const groundWidth = 1024;
	const tileSize = 16;
	groundBuffer = createGraphics(groundWidth, tileSize);
	groundBuffer.image(landTileLeft, 0, 0);
	for (let x = tileSize; x < groundWidth - tileSize; x += tileSize) {
		groundBuffer.image(landTileMiddle, x, 0);
	}
	groundBuffer.image(landTileRight, groundWidth - tileSize, 0);

	// Setup callbacks (after sprites loaded so closures have correct references)
	setupCatCallbacks(groundLevel);

	// Kamerayı başlangıç pozisyonuna ayarla
	cameraX = cat.x + 32;
	cameraY = cat.y - 40;
	isLoading = false;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).draw = function () {
	gameTime.update();

	background(100, 155, 255);

	if (isLoading) {
		fill(255);
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		textAlign((window as any).CENTER, (window as any).CENTER);
		textSize(32);
		text('Loading...', width / 2, height / 2);
		return;
	}

	// Restart kontrolü (Gamepad Start veya ESC)
	const canRestart = cat.isDeathAnimationComplete;
	if (canRestart) {
		if (inputManager.isStartPressed()) {
			if (!lastStartButtonState) {
				resetGame();
			}
			lastStartButtonState = true;
		} else {
			lastStartButtonState = false;
		}

		if (inputManager.isEscapePressed()) {
			resetGame();
		}
	} else {
		// Normal gamepad start kontrolü (her zaman çalışır)
		if (inputManager.isStartPressed()) {
			if (!lastStartButtonState) {
				resetGame();
			}
			lastStartButtonState = true;
		} else {
			lastStartButtonState = false;
		}
	}

	// Pass pit bounds for proximity slowdown
	cat.nearbyPitBounds = pit.getBounds();

	cat.handleInput();

	// Remove destroyed poops
	for (let i = poops.length - 1; i >= 0; i--) {
		if (poops[i].shouldRemove()) {
			collisionManager.unregister(poops[i]);
			poops.splice(i, 1);
		}
	}

	// Reset collision state before checking
	cat.isCollidingWithTree = false;
	cat.activeTree = null;

	// Check collisions (triggers callbacks like handlePitCollision, handleTreeCollision)
	collisionManager.checkCollisions(cat);

	cat.update();

	// Update HUD state
	hud.setHealth(cat.currentHealth);
	hud.setColliding(cat.isCollidingWithTree);
	hud.setGameOver(cat.isDeathAnimationComplete && cat.isDead());
	hud.setRestartPrompt(cat.isDeathAnimationComplete && !cat.isDead());

	// Kamera smooth takip: kedinin pozisyonuna doğru yumuşak geçiş
	// Y offset negatif = kamera yukarı kayar, daha fazla gökyüzü görünür
	const targetCameraX = cat.x + 32;
	// Sneak modunda kamera aşağı eğilir
	const sneakCameraOffset = cat.isCrouching ? 30 : 0;
	const targetCameraY = cat.y - 40 + sneakCameraOffset;
	cameraX = lerp(cameraX, targetCameraX, cameraLerpSpeed);
	// Sneak kamera geçişi için biraz daha yavaş lerp
	const cameraYLerpSpeed = cat.isCrouching ? 0.025 : cameraLerpSpeed;
	cameraY = lerp(cameraY, targetCameraY, cameraYLerpSpeed);

	push();
	translate(width / 2, height / 2);
	scale(cameraZoom);
	// Round camera coords to prevent subpixel rendering seams
	translate(-Math.round(cameraX), -Math.round(cameraY));

	// Ground (kahverengi toprak, tile'ın altından başlar)
	noStroke();
	fill(86, 48, 41); // #563029
	rect(0, 432 + 16, 1024, 128);

	// Land tiles - pre-rendered buffer (seam-free)
	if (groundBuffer) {
		image(groundBuffer, 0, 432);
	}

	// Clouds (animated)
	cloudManager.update();
	cloudManager.draw();

	canyon.draw();
	tree.draw();
	pit.draw();
	collectable.draw();
	// Check glass collisions (for pit falling)
	collisionManager.checkCollisions(glass);
	glass.update();
	glass.draw();

	// Update and draw poops
	for (const poop of poops) {
		collisionManager.checkCollisions(poop);
		poop.update();
		poop.draw();
	}

	cat.draw();
	pop();

	// HUD overlay (health bar, FPS, game over messages)
	hud.draw();
};
